<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" PagingC>
          <Paging
            :resourceSettings="resourceSettings"
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-col>

        <v-col cols="12" FILTERS>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0">
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <DateField
                    label="Create date"
                    :modelValue="filters.created_at"
                    icon="calendar_today"
                    @update:modelValue="(value) => (filters.created_at = value)"
                  />
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-autocomplete
                    :items="candidates"
                    :label="i18n.candidate"
                    :class="`${arabic ? 'arFont' : 'enFont'}`"
                    v-model="filters.candidate_id"
                    outlined
                    hide-details
                    dense
                    clearable
                    item-text="name"
                    item-value="id"
                  />
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-select
                    label="Submission status"
                    dense
                    outlined
                    hide-details
                    :items="status_items"
                    v-model="filters.submission_status"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col class="mx-auto" cols="2" style="max-width: fit-content;">
          <v-btn @click.prevent="() => (dialog = true)" color="primary">
            <v-icon>add</v-icon>
            <span>New</span>
          </v-btn>
        </v-col>
        <v-col cols="12" updates>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                  v-for="(submission, s) in resource.data"
                  :key="'sub-' + s"
                  class="elevation-1 mb-2 py-0"
                >
                  <v-row class="align-center">
                    <v-col class="col-auto">
                      <v-avatar size="40" color="primary">
                        <span class="white--text text-h5">{{ firstTowLettersName(submission.employee_name.name) }}</span>
                      </v-avatar>
                    </v-col>
                    <v-col>
                      <div style="font-size:11px;font-weight:700;">{{ i18n.employee }}</div>
                      <strong>{{ submission.employee_name.name }}</strong>
                    </v-col>
                  </v-row>
                  <v-row class="align-center">
                    <v-col cols="12" md="2" :class="`${arabic ? 'arFont' : 'enFont'}`">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size: 11px; font-weight: 700;">{{ i18n["candidate"] }}</div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ submission.candidate.name }}</div>
                    </v-col>
                    <v-col cols="12" md="2" :class="`${arabic ? 'arFont' : 'enFont'}`">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size: 11px; font-weight: 700;">{{ i18n["request_title"] }}</div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ submission.request }}</div>
                    </v-col>
                    <v-col cols="12" md="3" :class="`${arabic ? 'arFont' : 'enFont'}`">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size: 11px; font-weight: 700;">{{ i18n["type"] }}</div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ submission.type }}</div>
                    </v-col>
                    <v-col cols="12" md="1">
                      <v-chip
                        v-if="!submission.submission"
                        color="error"
                        :class="`${arabic ? 'arFont' : 'enFont'} mx-2`"
                        >{{ i18n.pending }}</v-chip
                      >
                      <v-chip
                        v-if="submission.submission"
                        color="success"
                        :class="`${arabic ? 'arFont' : 'enFont'} mx-2`"
                        >{{ i18n.submited }}</v-chip
                      >
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-btn small color="primary" class="mr-2" @click.prevent="editSubmission(submission)">
                        <v-icon small class="mr-1">edit</v-icon>
                        <span>Edit</span>
                      </v-btn>
                      <v-btn small color="error" @click.prevent="deleteSubmission(submission)">
                        <v-icon small class="mr-1">delete</v-icon>
                        <span>Delete</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-divider v-if="submission.submission"></v-divider>
                  <v-row class="align-center" v-if="submission.submission">
                    <v-col cols="12" md="12">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n["already_submited"] }}</div>
                      <div
                        v-if="!submission.submission.includes('https://')"
                        :class="`${arabic ? 'arFont' : 'enFont'}`"
                      >
                        {{ submission.submission }}
                      </div>
                      <div v-else>
                        <a :href="submission.submission" :class="`${arabic ? 'arFont' : 'enFont'}`">{{
                          i18n["submited_review"]
                        }}</a>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <multiDialog
      :dialog="dialog"
      :loading="loading"
      :resourceSettings="resourceSettings"
      :deleting="deleting"
      :resourceKeys="resourceKeys"
      :newResource="newResource"
      @closeDialog="
        () => {
          dialog = false;
          newResource = {};
        }
      "
      @updateResource="updateResource"
      @postResource="postResource"
      @deleteResource="deleteResource"
    />
  </v-row>
</template>

<script>
import Paging from "@/components/Paging";
import multiDialog from "@/components/multiDialog";
import { format } from "timeago.js";
import DateField from "../components/partials/DateField.vue";
import _ from "lodash";

export default {
  components: {
    Paging,
    multiDialog,
    DateField,
  },
  data() {
    const types = [
      {text: 'Text', type_id: 'text'},
      {text: 'Number', type_id: 'number'},
      {text: 'Textarea', type_id: 'textarea'},
      {text: 'Switch', type_id: 'switch'},
      {text: 'Upload', type_id: 'upload'},
    ]

    return {
      dialog: false,
      loading: false,
      loading: false,
      deleting: false,
      resourceKeys: [
        { name: "request", label: "request", type: "text", required: true, readonly: false },
        { name: "type", label: "type", type: "select", data: types, required: true, readonly: false },
        {
          name: "candidate_id",
          label: "candidate",
          type: "select",
          items: "candidates",
          data: [],
          source: "db",
          required: true,
          readonly: false,
        },
      ],
      newResource: {},
      page: 1,
      loading: false,
      resource: [],
      filters: {
        created_at: null,
        candidate_id: null,
        submission_status: null,
      },
      status_items: [
        { text: "Any", value: null },
        { text: "Submitted", value: true },
        { text: "Pending", value: false },
      ],
      candidates: [],
      resourceSettings: {
        resourceName: "submissionRequests",
        create: true,
        pagination: true,
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
  watch: {
    filters: {
      handler: _.debounce(function() {
        this.loadResource();
      }, 500),
      deep: true,
    },
  },
  methods: {
		firstTowLettersName(name) {
			const split_names = name.split(" ")

			if (split_names.length == 0) return ""

			if (split_names.length > 1) return (split_names[0][0] + split_names[1][0]).toUpperCase()

			return (split_names[0][0] + split_names[0][1]).toUpperCase()
		},
    formatDateToCurrentLocale(date) {
      let new_date = new Date(date);
      return [
        new_date.toLocaleDateString(this.arabic ? "ar" : "en", {
          day: "numeric",
          year: "numeric",
          month: "short",
        }),
        new_date.toLocaleTimeString(this.arabic ? "ar" : "en"),
      ];
    },
    deleteResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true;
        await this.$store.dispatch("deleteResource", { resource: `/can/delete_/submission_requests/${r.id}` });
        this.dialog = false;
        this.deleting = false;
        this.loading = false;
        await this.loadResource();
        this.newResource = {};
        res(true);
      });
    },
    deleteSubmission(e) {
      this.newResource = e;
      this.deleting = true;
      this.dialog = true;
    },
    editSubmission(e) {
      this.newResource = {
        ...e,
      };
      this.dialog = true;
    },
    getFormat(d) {
      return format(d);
    },
    buildFilter() {
      let filter = ``;
      Object.keys(this.filters).map((key) => {
        let value = this.filters[key];
        if (value != null) {
          filter += `&filter[${key}]=${value}`;
        }
      });
      return filter;
    },
    updateResource(r) {
      return new Promise(async (res, rej) => {
        r.appointment = `${r.appointment} ${r.appointment_time}`;
        this.loading = true;

        await this.$store.dispatch("putResource", {
          resource: `/can/update_/submission_requests/${r.id}`,
          value: r,
        });

        this.dialog = false;
        this.loading = false;
        this.newResource = {};

        await this.loadResource();

        res(true);
      });
    },
    postResource() {
      return new Promise(async (res, rej) => {
        this.newResource.appointment = this.newResource.appointment + " " + this.newResource.appointment_time;
        delete this.newResource.appointment_time;

        this.loading = true;

        await this.$store.dispatch("postResource", {
          resource: "/can/create_/submission_requests",
          value: this.newResource,
        });

        this.dialog = false;
        this.loading = false;
        this.newResource = {};

        await this.loadResource();

        res(true);
      });
    },
    loadResource() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        this.resource = await this.$store.dispatch("getResource", {
          resource: "/can/get_all_/submission_requests",
          page: `?page=${this.page}` + this.buildFilter(),
        });
        this.loading = false;

        await this.loadItems();

        res(true);
      });
    },
    pageByNumber(n) {
      return new Promise(async (res, rej) => {
        this.loading = true;
        this.page = n;
        this.resource = await this.$store.dispatch("getResource", {
          resource: "/can/get_all_/submission_requests",
          page: `?page=${n}` + this.buildFilter(),
        });
        this.loading = false;
        res(true);
      });
    },
    async loadItems() {
      return new Promise(async (res, rej) => {
        let iks = ["candidates"];

        for (let i = 0; i < iks.length; i++) {
          const f = iks[i];
          let t = this.resource[f];
          if (!t.error) {
            t.forEach((x) => (this.$store.state.i18n.en[x.slug] = x.en));
            t.forEach((x) => (this.$store.state.i18n.ar[x.slug] = x.ar));
            t.forEach((x) => (this.$store.state.i18n.fr[x.slug] = x.fr));
            this[f] = t;
          }
        }

        let ks = this.resourceKeys.filter((x) => x.type == "select" && x.source == "db");

        (async (x) => {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            console.log(f.items);
            f.data = this.resource[f.items].map((x) => {
              return {
                ...x,
                text: x.name ? x.name : x.en ? x.en : "unknown",
                [`${f.name}_id`]: x.id,
              };
            });
          }
          res(true);
        })();
      });
    },
  },
  async created() {
    await this.loadResource();
  },
};
</script>
